const types = {
    SET_USERS_LIST: '[USERS] SET USERS LIST',
    SET_USER_BY_ID: '[USERS] SET USER BY ID',
    SET_WITHDRAWALS_USER: '[USERS] SET WITHDRAWALS USER',
    SET_REPLENISHMENT_USER: '[USERS] SET REPLENISHMENT USER',
    SET_HISTORY_GAMES_USER: '[USERS] SET HISTORY GAMES USER',
    SET_BONUSES_HISTORY: '[USERS] SET BONUSES HISTORY',
    SET_LAST_OPERATION: '[USERS] SET LAST OPERATION',
    SET_REZYME: '[USERS] SET REZYME',
    SET_VERIFICATION: '[USERS] SET VERIFICATION',
    SET_HISTORY_LIST: '[HISTORY] SET HISTORY LIST',
    SET_FREESPIN_OPERATION: '[USERS] SET FREESPIN OPERATION',
    SET_USER_LOGGER: '[USERS] SET USER LOGGER',
    SET_GAMES_LIST: '[GAMES] SET GAMES FS',
    SET_BET: '[GAMES] SET BET',
    SET_GET_TAGS: '[USERS] SET GET TAGS',
}

export {
    types
}